import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { privateRoute, publicRoute } from "./allRoutes";
import Layout from "./layout";
import PortalWalkthrough from "pages/walkthrough";
import { routeConstant } from "./routeConstant";

function AuthRoute() {
  const {
    auth: { isLoggedIn, user },
  } = useSelector((state: any) => state.root);

  const getDefaultRoute = () => {
    const userType = user?.user_type;

    const defaultRoutes: { [key: string]: string } = {
      client: routeConstant.client.projects.path,
      designer: routeConstant.designer.home.path,
      builder: routeConstant.builder.projects.path,
      collaborator: routeConstant.collaborator.projects.path,
    };

    return defaultRoutes[userType] || routeConstant.designer.home.path;
  };

  const routes = !isLoggedIn ? publicRoute : privateRoute;

  return (
    <>
      <Routes>
        {/* Public, session-agnostic: linked from the welcome email, so it must render either way. */}
        <Route
          path={routeConstant.portalWalkthrough.path}
          element={<PortalWalkthrough />}
        />
        {routes.map((route: any, inx: any) => {
          return (
            <Route
              key={inx}
              path={route.path}
              element={<Layout {...route} />}
            />
          );
        })}
        <Route
          path="*"
          element={
            <Navigate
              to={!isLoggedIn ? routeConstant.login.path : getDefaultRoute()}
              replace
            />
          }
        />
      </Routes>
    </>
  );
}

export default AuthRoute;
